/****************************************************
 * Module Name:  workerProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class WorkerProxy {
  static GetAllWorker = (callback) => {
    restAPICall(
      Constants.WORKER_URL + "/worker",
      "get",
      undefined,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleWorker = (workerId, callback) => {
    let params = {
      id: workerId,
    };

    restAPICall(
      Constants.WORKER_URL + "/worker",
      "get",
      undefined,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckWorkerAvailable = (worker, callback) => {
    let params = {
      worker: worker,
    };

    restAPICall(
      Constants.WORKER_URL + "/worker/available",
      "get",
      undefined,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddWorker = (worker, callback) => {
    restAPICall(
      Constants.WORKER_URL + "/worker",
      "post",
      undefined,
      undefined,
      JSON.stringify(worker),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateWorker = (worker, callback) => {
    restAPICall(
      Constants.WORKER_URL + "/worker",
      "put",
      undefined,
      undefined,
      JSON.stringify(worker),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteWorker = (worker, callback) => {
    restAPICall(
      Constants.WORKER_URL + "/worker",
      "delete",
      undefined,
      undefined,
      JSON.stringify(worker),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetFilteredIgi = (
    status,
    startdatetime,
    enddatetime,
    limit,
    certificateids,
    callback
  ) => {
    let params = {
      startdatetime: startdatetime,
      enddatetime: enddatetime,
      limit: limit,
    };

    restAPICall(
      Constants.WORKER_URL + `/igi/status/${status}`,
      "post",
      undefined,
      params,
      JSON.stringify(certificateids),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetFilteredGia = (
    status,
    startdatetime,
    enddatetime,
    limit,
    certificateids,
    callback
  ) => {
    let params = {
      startdatetime: startdatetime,
      enddatetime: enddatetime,
      limit: limit,
    };

    restAPICall(
      Constants.WORKER_URL + `/gia/status/${status}`,
      "post",
      undefined,
      params,
      JSON.stringify(certificateids),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetChangeIgiCertificateStatus = (
    oldstatus,
    newstatus,
    certificateids,
    callback
  ) => {

    restAPICall(
      Constants.WORKER_URL + `/igi/status/${oldstatus}/${newstatus}`,
      "post",
      undefined,
      undefined,
      JSON.stringify(certificateids),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetChangeIgiCertificatePriority = (
    priority,
    certificateids,
    callback
  ) => {

    restAPICall(
      Constants.WORKER_URL + `/igi/priority/${priority}`,
      "put",
      undefined,
      undefined,
      JSON.stringify(certificateids),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetFilteredHrd = (
    status,
    startdatetime,
    enddatetime,
    limit,
    certificateids,
    callback
  ) => {
    let params = {
      startdatetime: startdatetime,
      enddatetime: enddatetime,
      limit: limit,
      certificateids: certificateids,
    };

    restAPICall(
      Constants.WORKER_URL + `/hrd/status/${status}`,
      "post",
      undefined,
      params,
      JSON.stringify(certificateids),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetChangeHrdCertificateStatus = (
    oldstatus,
    newstatus,
    certificateids,
    callback
  ) => {

    restAPICall(
      Constants.WORKER_URL + `/hrd/status/${oldstatus}/${newstatus}`,
      "post",
      undefined,
      undefined,
      JSON.stringify(certificateids),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetChangeGiaCertificateStatus = (
    oldstatus,
    newstatus,
    certificateids,
    callback
  ) => {

    restAPICall(
      Constants.WORKER_URL + `/gia/status/${oldstatus}/${newstatus}`,
      "post",
      undefined,
      undefined,
      JSON.stringify(certificateids),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddIgiCertificate = (certificateIds, priority, forcerefetch, callback) => {
    let params = {
      priority: priority,
      forcerefetch: forcerefetch,
    };
    restAPICall(
      Constants.WORKER_URL + "/igi",
      "post",
      undefined,
      params,
      JSON.stringify(certificateIds),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddHrdCertificate = (certificateIds, callback) => {
    restAPICall(
      Constants.WORKER_URL + "/hrd",
      "post",
      undefined,
      undefined,
      JSON.stringify(certificateIds),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddGiaCertificate = (certificateIds, callback) => {
    restAPICall(
      Constants.WORKER_URL + "/gia",
      "post",
      undefined,
      undefined,
      JSON.stringify(certificateIds),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllIgiStats = (callback) => {
    restAPICall(
      Constants.WORKER_URL + "/igi/stats",
      "get",
      undefined,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }

  static GetAllHrdStats = (callback) => {
    restAPICall(
      Constants.WORKER_URL + "/hrd/stats",
      "get",
      undefined,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }

  static GetAllGiaStats = (callback) => {
    restAPICall(
      Constants.WORKER_URL + "/gia/stats",
      "get",
      undefined,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }
}
